export const LOAD_SETTINGS = 'settings/LOAD_SETTINGS';
export const CHANGE_SETTING = 'settings/CHANGE_SETTING';
